import CreateFundOpportunityModal from 'CreateFundOpportunityModal';
import { Permissions } from 'Permission';
import { usePermissions } from 'PermissionContext';
import React from 'react';

export default function CreateOppModalWithPermissions({
  showCreateOppModal,
  newOppName,
  newOppSummaryTitle,
  newOppNameError,
  newOppSummaryTitleError,
  submitNewOpp,
  setShowCreateOppModal,
  setNewOppName,
  setNewOppSummaryTitle,
}: {
  showCreateOppModal: boolean;
  newOppName: string;
  newOppSummaryTitle: string;
  newOppNameError: string | null;
  newOppSummaryTitleError: string | null;
  submitNewOpp: () => void;
  setShowCreateOppModal: (value: boolean) => void;
  setNewOppName: (value: string) => void;
  setNewOppSummaryTitle: (value: string) => void;
}) {
  const permissions = usePermissions();

  // This modal is the *non*-AI creation path — useCreateOpportunity.ts's
  // createOpportunity() only ever sets showCreateOppModal=true in the
  // branch where the admin does NOT have AIEntityCreation (an
  // AI-permitted admin is navigated to /opportunities/new instead). It
  // must not also require AIEntityCreation here, or the two conditions
  // are mutually exclusive and this modal can never render for anyone.
  return permissions.hasPermission(Permissions.FundOpportunityCreation) ? (
    <CreateFundOpportunityModal
      open={!!showCreateOppModal}
      onClose={() => setShowCreateOppModal(false)}
      newOppName={newOppName}
      setNewOppName={setNewOppName}
      newOppSummaryTitle={newOppSummaryTitle}
      setNewOppSummaryTitle={setNewOppSummaryTitle}
      newOppNameError={newOppNameError || undefined}
      newOppSummaryTitleError={newOppSummaryTitleError || undefined}
      onSubmit={submitNewOpp}
    />
  ) : null;
}
